import { useEffect } from 'react';

import { usePathname } from 'expo-router';

import { useExperiments } from 'state/experiments';
import { RunningExperiments } from 'state/experiments';
import { routes } from 'utils/routing';

export const useEnableCheckoutV2Experiment = () => {
  const { variant, logExposure } = useExperiments();
  const pathname = usePathname();

  useEffect(() => {
    if (pathname === routes.cart) {
      logExposure(RunningExperiments.CheckoutV2);
    }
  }, [logExposure, pathname]);

  return variant(RunningExperiments.CheckoutV2, 'treatment', {
    skipExposureLogging: true,
  });
};
